export const LAYOUT_SPRING = {
  type: 'spring',
  stiffness: 700,
  damping: 50,
  mass: 0.5,
  restDelta: 0.5,
} as const;

export const SHELL_SPRING = {
  type: 'spring',
  stiffness: 700,
  damping: 40,
  mass: 0.4,
} as const;

export const OPACITY_FADE = { duration: 0.08, ease: 'easeOut' } as const;

export const FOLDER_DROP_THRESHOLDS = { above: 0.35, below: 0.65 } as const;

export const ITEM_DROP_MIDPOINT = 0.5;

export const DRAG_OPACITY_DIM = 0.55;
export const DRAG_SCALE_DOWN = 0.98;
